export const DEFAULT_ANNOUNCEMENT_LOGO = '/images/pana.svg';

const logoUrl = (value) =>
  typeof value === 'string' ? value.trim() : '';

export const getAnnouncementLogo = (announcement = {}, client) =>
  logoUrl(announcement?.configuration?.platform?.logo) ||
  logoUrl(client?.logo) ||
  logoUrl(announcement?.logo) ||
  DEFAULT_ANNOUNCEMENT_LOGO;

export const getAnnouncementLandingPayload = (landing = {}, client) => {
  if (!client?.id) {
    return { ...landing };
  }

  // The client owns the inherited logo; do not send a historical copy back.
  const { logo, ...payload } = landing;
  return payload;
};
